import { vue } from '@/main'

export default function () {
  return [
    {
      // Hidden on the monetary view (which uses the CalendarBar above the
      // filters instead); still shown on the withdrawal-requests view.
      key: 'registrationTime',
      type: 'dateRange',
      // localTime: the backend compares this against a server-local LocalDate,
      // so send the picked dates as-is (no UTC shift) to avoid an off-by-one
      // (e.g. filtering May 1-31 wrongly including Apr 30).
      props: { mode: 'dateTime', localTime: true }
    },
    {
      key: 'userIds',
      label: 'depositor',
      type: 'user',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'status',
      type: 'monetaryStatus',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'action',
      label: "monetaryAction",
      type: 'monetaryAction',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'realType',
      label: "monetaryRealType",
      type: 'monetaryRealType',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'account',
      label: 'account'
    },
    {
      key: 'clientDetails.clientId',
      label: 'client',
      type: 'clientId',
      props: {
        clearable: true,
        multiple: false
      }
    },
    {
      key: 'clientEmail',
      label: 'clientEmail'
    },
    {
      key: 'affiliateId',
      type: 'affiliate',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'businessUnit',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },
    {
      key: 'maxAmount',
      label: 'maxAmount',
      type: 'number'
    },
    {
      key: 'minAmount',
      label: 'minAmount',
      type: 'number'
    },
    // {
    //   key: 'registrationTime',
    //   label: 'registrationTime',
    //   type: 'dateRange',
    //  props: {mode:"dateTime"}
    // },
    {
      // One switch instead of two boxes: CRM = created by a user in the CRM
      // (creatorUserId set), Website = client-made (no creatorUserId).
      key: 'source',
      label: 'source',
      type: 'select',
      props: {
        options: [
          { value: 'CRM', label: vue.$t('filters.fromCrm') },
          { value: 'WEBSITE', label: vue.$t('filters.fromWebsite') },
        ],
        reduce: option => option.value,
        clearable: true,
        multiple: false,
      }
    },
    {
      type: "checkboxGroup",
      fields: [
        {
          key: 'isFtd',
          label: 'isFtd',
          type: 'checkbox',
          // Unchecking must REMOVE the filter (null = no filter), not set false
          // (which the backend reads as "non-FTD only" and skews the numbers).
          props: { uncheckedValue: null }
        },
        {
          key: 'isStd',
          label: 'isStd',
          type: 'checkbox',
          props: { uncheckedValue: null }
        },
        {
          key: 'isTest',
          label: 'isTest',
          type: 'checkbox'
        }
        // No "Include TXF" checkbox: TXF rows are hidden by default (isTxf
        // false) and revealed by explicitly picking the TXF monetary action in
        // the action filter — an explicit action filter wins over the default.
      ]
    }
  ];
}
